// @flow

import type { PropsSchema, EasyAction, BasicProps } from '../../type'
import type { Visitor } from 'projects/easy/public/type'

import { mClient } from 'frame/net/clientFactory'
import * as React from 'react'
import computeData from '../hoc/computeData'
import $ from 'jquery'
import { isInEditor } from '../../pageInfo'

type Props = BasicProps & {
  style: { [string]: string },
  field: string,
  visitor: Visitor,
  query: { [string]: string },
  placeholder: string,
  setFormValues: ({ [key: string]: any }) => void
};

type State = {
  randomKey?: ?string,
  randomValue?: ?string,
  passGuard?: ?string
};

@computeData()
export default class InputText extends React.PureComponent<Props, State> {
  static defaultProps = {
    type: 'text'
  };

  constructor (props: Props) {
    super(props)
    this.keyboardComponentPromise = Promise.all([
      import('./microdonemobile.min.js'),
      import('./microdone-h5.css')
    ]).then(([keyboardComponent]) => {
      return keyboardComponent
    })
  }

  keyboardComponentPromise: Promise<*>;

  static schema: PropsSchema = [
    {
      key: 'field',
      title: '字段',
      type: 'text'
    },
    {
      key: 'placeholder',
      title: '占位内容',
      type: 'text'
    },
    'separator',
    {
      type: 'event',
      title: '键盘弹起',
      event: 'keyboardShow'
    },
    {
      type: 'event',
      title: '输入成功',
      event: 'success'
    },
    {
      type: 'event',
      title: '输入失败',
      event: 'fail'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '重置密码',
      name: 'resetPwd'
    }
  ];

  actionResetPwd = () => {
    this.getRandomKey()
  };
  getRandomKey = () => {
    mClient
      .postJson('/v2/common/backendPostRequireLogin', {
        path: '/pay/api/v3/ceres/getRandomKey/MYSELF'
      })
      .then(data => {
        this.setState({
          randomValue: data.randomValue
        })
        let { setFormValues } = this.props
        setFormValues({ randomKey: data.randomKey })
      })
      .catch(err => {
        console.log('密码因子失效', err)
      })
  };
  callbackFn = (passGuard1: any) => {
    const { callActions } = this.props
    if (passGuard1.valueStr && passGuard1.valueStr.length === 6) {
      let { field, setFormValues } = this.props
      passGuard1.setRandKey(this.state.randomValue)
      setFormValues({ [field]: passGuard1.getOutput() })
      callActions('success')
    } else {
      callActions('fail')
    }
  };

  initBjInput = () => {
    this.getRandomKey()
    this.keyboardComponentPromise.then(keyboardComponent => {
      // eslint-disable-next-line
      window.kb = new keyboardComponent.keyBoard({
        chaosMode: 1, // 混乱模式,0:无混乱;1:打开时乱一次;2:每输入一个字符乱一次,默认值0
        pressStatus: 1, // 按键状态,0:按下、抬起按键无变化;1:按下、抬起按键的颜色变化,默认值0
        kbType: 1, // 键盘类型,0:全键盘;1:纯数字键盘,默认值0
        odd: 51, // 按键异或值
        svg: '/svg' // svg图片的地址
      })
      // eslint-disable-next-line
      window.passGuard1 = new keyboardComponent.passGuard({
        mappurl:
          'Wyc4MicsICc2NycsICc0MCcsICc5NCcsICcxMDInLCAnMzgnLCAnNzYnLCAnOTcnLCAnNjEnLCAnNzInLCAnODUnLCAnNjUnLCAnNDMnLCAnMTE1JywgJzEyMScsICcxMjAnLCAnMTE2JywgJzEyMycsICc1NCcsICc3NycsICcxMTgnLCAnNjgnLCAnODcnLCAnMzMnLCAnMTE3JywgJzEyMicsICcxMDQnLCAnNTYnLCAnMTAxJywgJzExMScsICc0NScsICc3MCcsICc5MycsICczNycsICc3MycsICczOScsICc1MCcsICc0NycsICcxMjQnLCAnMTE5JywgJzExMCcsICc4MCcsICc3NScsICc2MicsICcxMTInLCAnOTAnLCAnMTEzJywgJzUyJywgJzM2JywgJzExNCcsICc3OCcsICcxMDcnLCAnNDknLCAnODknLCAnODMnLCAnNDYnLCAnNTknLCAnNDEnLCAnODYnLCAnOTEnLCAnNDInLCAnNTUnLCAnMzUnLCAnOTgnLCAnMTA1JywgJzM0JywgJzEyNicsICc5OScsICc1NycsICc0OCcsICcxMjUnLCAnMTAwJywgJzYwJywgJzY0JywgJzcxJywgJzgxJywgJzk1JywgJzc5JywgJzkyJywgJzEwOScsICcxMDMnLCAnODQnLCAnNjknLCAnODgnLCAnNTgnLCAnOTYnLCAnNjYnLCAnMTA4JywgJzUzJywgJzEwNicsICc2MycsICc1MScsICc3NCcsICc0NCdd',
        jump: 0, // 自动跳转，0:不跳转;1:跳转
        maxLength: 6, // 最大输入长度
        regExp1: '[0-9]',
        regExp2: '^[0-9]{6,6}$',
        displayMode: 0, // 显示形式,0:星号;1:明文,默认值0
        callBack: () => {
          this.callbackFn(window.passGuard1)
        }, // 成功回调
        errorCallBack: () => {
          this.callbackFn(window.passGuard1)
        }, // 失败回调
        simple: () => {
          window.kb.hide()
        }, // 密码简单回调
        rsaPublicKey:
          '3081890281810092d9d8d04fb5f8ef9b8374f21690fd46fdbf49b40eeccdf416b4e2ac2044b0cfe3bd67eb4416b26fd18c9d3833770a526fd1ab66a83ed969af74238d6c900403fc498154ec74eaf420e7338675cad7f19332b4a56be4ff946b662a3c2d217efbe4dc646fb742b8c62bfe8e25fd5dc59e7540695fa8b9cd5bfd9f92dfad009d230203010001' // rsa公钥
      })

      var Le = $('.default').length
      for (var i = 1; i <= Le; i++) {
        $('#kb' + i).val('')
      }
      setTimeout(() => {
        window.kb.generate()
        // $('#kb1').trigger('click').focus()// 调用键盘
      }, 100)
      window.passGuard1.generate('kb1', window.kb, 1)
      let { callActions } = this.props
      $('#kb1').click(() => {
        callActions('keyboardShow')
      })
    })
  };

  componentDidMount () {
    if (!isInEditor()) {
      this.initBjInput()
    }
  }

  render () {
    if (!this.props.visible) {
      return null
    }
    const { style, jsEnv, placeholder } = this.props
    return (
      <input
        id='kb1'
        className='default'
        placeholder={jsEnv.getString(placeholder)}
        style={style}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/form/BjFormInputPwd.js